module.exports = __webpack_public_path__ + "BY.png?d4b7a07b9ae7e84f47413266c59601cd";